import { Bell } from "lucide-react";

import { CommandMenu } from "@/core/components/layout/command-menu";
import { ModeToggle } from "@/core/components/layout/mode-toggle";
import { NotificationDropdown } from "@/core/components/layout/notification-dropdown";
import { ProfileDropdown } from "@/core/components/layout/profile-dropdown";
import { Button } from "@/core/components/ui/button";
import { Separator } from "@/core/components/ui/separator";
import { SidebarTrigger } from "@/core/components/ui/sidebar";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import {
  selectUnreadCount,
  useNotificationStore,
} from "@/core/stores/notification.store";

export function AppHeader() {
  const { t } = useTypedTranslation();
  const unreadCount = useNotificationStore(selectUnreadCount);

  return (
    <header className="sticky top-0 z-50 px-3 before:absolute before:inset-0 before:rounded-t-xl before:backdrop-blur-md before:[mask-image:linear-gradient(hsl(var(--card)),hsl(var(--card))_18%,transparent_100%)] sm:px-6">
      <div className="relative z-[51] mx-auto mt-3 flex w-full min-w-0 items-center justify-between rounded-xl border bg-card px-3 py-2 sm:px-6">
        <div className="flex min-w-0 items-center gap-1.5 sm:gap-4">
          <SidebarTrigger
            className="[&_svg]:size-5"
            aria-label={t("layout.sidebar.toggle")}
          />
          <Separator
            orientation="vertical"
            className="hidden h-4 self-center sm:block"
          />
          <CommandMenu />
        </div>
        <div className="flex shrink-0 items-center gap-1">
          <NotificationDropdown
            trigger={
              <Button
                variant="ghost"
                size="icon"
                className="relative"
                aria-label={t("layout.notifications.title")}
              >
                <Bell />
                {unreadCount > 0 && (
                  <span className="absolute right-2.5 top-2 size-2 rounded-full bg-destructive" />
                )}
              </Button>
            }
          />
          <ModeToggle />
          <ProfileDropdown />
        </div>
      </div>
    </header>
  );
}
